import { Box, Typography } from '@mui/material'
import { appConfig } from '@/config/app.ts'
import HomeModule from '@/modules/home/components/HomeModule.tsx'
import { useNavigate } from 'react-router-dom'
import { useAppDispatch, useAppSelector } from '@/globalStore/hooks.ts'
import { globalActions } from '@/globalStore/globalSlice/globalSlice.ts'
import { useGetAccessibleViewFromModule } from '@/core/hooks/useGetAccessibleViewFromModule.ts'
import { getViewUrlFromModule } from '@/core/utils/general.ts'
import useHasPermissions from '@/core/hooks/useHasPermissions.ts'

const HomeContainer = () => {
  const { loggedUser } = useAppSelector((state) => state.global)
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const { getFirstAccessibleView } = useGetAccessibleViewFromModule()
  const { hasPermissions } = useHasPermissions()

  const allowedModules = appConfig.systemModules
    .filter((module) => {
      if (module.systemName === 'marketplace' && loggedUser)
        return (
          (loggedUser.isWeppa || loggedUser.hasMarketplace) &&
          module.views.some((view) => hasPermissions([view.permission]))
        )
      return module.views.some((view) => hasPermissions([view.permission]))
    })
    .map((module, i) => {
      const firstAccessibleView = getFirstAccessibleView(module)

      if (!firstAccessibleView) return undefined

      const moduleName = module.systemName
      const viewName = firstAccessibleView.systemName

      const accessibleUrl = getViewUrlFromModule(moduleName, viewName as string)

      return (
        <HomeModule
          key={i}
          module={module}
          onClick={() => {
            dispatch(globalActions.setCurrentModuleName(module.systemName))
            navigate(accessibleUrl)
          }}
        />
      )
    })

  return loggedUser && allowedModules.length > 0 ? (
    allowedModules
  ) : (
    <Box sx={{ mt: 17, textAlign: 'center' }}>
      <Typography variant="h6">
        Su usuario no tiene ningún permiso de acceso a módulos.
      </Typography>
      <Typography variant="subtitle1" mt={1}>
        Si cree que es un error, contacte a su administrador.
      </Typography>
    </Box>
  )
}
export default HomeContainer
